import { RouterConfig } from 'RouterConfig';

export const App = () => {
  return (
    <div className='App'>
      <RouterConfig />
    </div>
  );
};
